import type { Exercise } from '@/domain'
import type { v1Exercise } from '@/lib/api/pocket'

/**
 * Name to show for an exercise row.
 *
 * An authored item can carry no exercise at all (the picker was never used) or
 * point at one that is no longer in the catalogue. Both used to render the
 * lookup key itself — "excercise.name.undefined" — on the training timeline,
 * in history and inside the workout dialog. Fall back to a readable label
 * instead, and let callers tell the two cases apart.
 */
export function exerciseLabel(
    item: Pick<Exercise, 'exercise'>,
    getExercise: (slugOrId: string) => v1Exercise | undefined,
    geti18n: (slug: string) => string
): string {
    const reference = item.exercise
    if (!reference) return geti18n('excercise.name.unset')

    const slug = getExercise(reference)?.slug
    if (!slug) return geti18n('excercise.name.unknown')

    return geti18n('excercise.name.' + slug)
}

/** True when the row has no usable exercise behind it. */
export function isExerciseUnresolved(
    item: Pick<Exercise, 'exercise'>,
    getExercise: (slugOrId: string) => v1Exercise | undefined
): boolean {
    return !item.exercise || !getExercise(item.exercise)?.slug
}
